<template>
    <div>
        <hts-form-button
            icon-name="hi-plus-icon"
            icon-position="right"
            color="primary"
            :outline="false"
            @click="handleOpen()">
            Thêm nhà cung cấp
        </hts-form-button>

        <hts-modal
            :show="!!open"
            size="medium"
            :title="'Thêm nhà cung cấp vào đơn hàng ' + orderCode"
            @close="open = false">
            <hts-form
                :rules="formData.rules"
                @submit="handleAdd">
                <div class="flex flex-col gap-5">
                    <hts-select-cooperator
                        v-model="formData.data.vendorId"
                        v-model:name="formData.data.vendorName"
                        :label="$t('labels.vendor')"
                        type-cooperator="PARTNER"
                        prop="vendor"
                        name-select="vendor"
                        required
                        :creatable="true"
                        @change="
                            () => {
                                formData.data.contact = ''
                                formData.data.contactName = ''
                                formData.data.contactEmail = ''
                                formData.data.contactPhone = ''
                            }
                        " />

                    <hts-select-cooperator-contact
                        v-model="formData.data.contactId"
                        v-model:name="formData.data.contactName"
                        :label="$t('labels.contact')"
                        :disabled="!formData.data.vendorId"
                        :cooperator-id="formData.data.vendorId"
                        required
                        key-label="namePhone"
                        prop="contact"
                        name-select="contact"
                        :creatable="true"
                        :param-prepare="formData.data.vendorId"
                        @change="handleChangeContact" />

                    <hts-form-input
                        v-model="formData.data.contactEmail"
                        :label="$t('labels.email')"
                        disabled
                        required />
                    <hts-form-input
                        v-model="formData.data.contactPhone"
                        :label="$t('labels.phone')"
                        disabled
                        required />

                    <hts-form-input
                        v-model="formData.data.buyingPrice"
                        :label="$t('labels.price')"
                        class="w-full"
                        type="number"
                        required
                        prop="price" />
                </div>

                <div class="flex justify-end mt-5">
                    <hts-form-button
                        icon-position="right"
                        type="button"
                        :outline="false"
                        @click="handleClose">
                        {{ $t('labels.close') }}
                    </hts-form-button>

                    <hts-form-button
                        :loading="!!loading"
                        icon-position="right"
                        color="primary"
                        type="submit"
                        :outline="false">
                        {{ $t('labels.add') }}
                    </hts-form-button>
                </div>
            </hts-form>
        </hts-modal>

        <hts-modal
            :show="!!showConfirmMarkup"
            size="medium"
            type="confirm"
            :content="labelConfirmMarkup"
            @hide="showConfirmMarkup = false"
            @confirm="handleAdd({ confirmMarkup: true })" />
    </div>
</template>
<script setup lang="ts">
const props = defineProps({
  orderId: {
    type: String,
    require: true
  },
  orderCode: {
    type: String,
    require: true
  }
})

const emits = defineEmits(['update-allotment'])

const { orderId, orderCode } = toRefs(props)

const open = ref<Boolean>(false)
const loading = ref<Boolean>(false)

const showConfirmMarkup = ref<Boolean>(false)
const labelConfirmMarkup = ref('')

const formData = ref<{ [key: string]: any }>({
  data: {
    vendorId: '',
    vendorName: '',
    contactId: '',
    contactName: '',
    contactEmail: '',
    contactPhone: '',
    buyingPrice: null
  },
  rules: {
    vendor: 'required',
    contact: 'required',
    price: 'required|gt:0|max_value:999999999999999'
  }
})

const url = ref<{ [key: string]: any }>({
  add: $url.order.allotment.addVendor
})

const handleOpen = () => {
  open.value = true
}

const handleAdd = $lodash.debounce((options?: { [key: string]: any }) => {
  loading.value = true
  showConfirmMarkup.value = false
  if (!orderId?.value) {
    return
  }
  $api(url.value.add, { body: { ...formData.value.data, confirmMarkup: !!options?.confirmMarkup }, uriParams: { ORDER_ID: orderId.value } })
    .then((data: any) => {
      const resData: any = data.data.value

      if (resData.success) {
        loading.value = false
        const { comfirmMarkup, markup, minMarkupConfirm } = resData.data

        if (!comfirmMarkup) {
          process.client && $toast().success($t('labels.addSuccess'))
          reset()
          handleClose()
          loading.value = false
          emits('update-allotment', resData.data)

          return
        }

        if (markup < 0) {
          showConfirmMarkup.value = true
          labelConfirmMarkup.value = 'Giá trị markup âm. Bạn có muốn tiếp tục'
          return
        }

        if (markup < minMarkupConfirm) {
          showConfirmMarkup.value = true
          labelConfirmMarkup.value = `Giá trị markup nhỏ hơn giá trị markup cho phép ${minMarkupConfirm}%. Bạn có muốn tiếp tục`
        }
      } else {
        loading.value = false
      }
    })
    .catch(() => {
      loading.value = false
    })
}, 300)

const handleClose = () => {
  open.value = false
}

const handleChangeContact = (values: any) => {
  if (!Array.isArray(values) && !values.length) {
    formData.value.data.contactEmail = ''
    formData.value.data.contactPhone = ''
    return
  }

  formData.value.data.contactEmail = values[0]?.email
  formData.value.data.contactPhone = values[0]?.phone
}

const reset = () => {
  formData.value.data = {
    vendorId: '',
    vendorName: '',
    contactId: '',
    contactName: '',
    contactEmail: '',
    contactPhone: '',
    buyingPrice: null
  }
  showConfirmMarkup.value = false
}
</script>
